"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryLastCodeVerifierProvider = void 0;
/**
 * This gets overriden in app to use local storage instead
 */
var MemoryLastCodeVerifierProvider = /** @class */ (function () {
    function MemoryLastCodeVerifierProvider() {
        var _this = this;
        this.store = function (_a) {
            var code_verifier = _a.code_verifier;
            _this.last_code_verifier = code_verifier;
        };
        this.getLastVerifier = function () {
            return { code_verifier: _this.last_code_verifier };
        };
    }
    return MemoryLastCodeVerifierProvider;
}());
exports.MemoryLastCodeVerifierProvider = MemoryLastCodeVerifierProvider;
//# sourceMappingURL=MemoryLastCodeVerifierProvider.js.map